import { RAPTOR_ITEM_CLICK_ENDPOINT, RAPTOR_PAGE_VIEW_ENDPOINT, RAPTOR_SEARCH_ENDPOINT } from '~/features/raptor/constants';
import { buildURL } from '~/shared/utils/request/utils/buildURL';
import { fetcher } from '~/shared/utils/request/utils/fetcher';

type TrackRaptorGenericOpts = {
	market: string;
	culture: string;
};

type TrackRaptorItemClickOpts = TrackRaptorGenericOpts & {
	sku: string;
	raptorModule: string;
	pageId: string;
};

export const trackRaptorItemClick = ({ sku, raptorModule, pageId, market, culture }: TrackRaptorItemClickOpts) => {
	return fetcher(
		buildURL(RAPTOR_ITEM_CLICK_ENDPOINT, {
			sku,
			market,
			culture,
			module: raptorModule,
			page: pageId,
		}),
	)();
};

type TrackRaptorSearchOpts = TrackRaptorGenericOpts & {
	query: string;
};

export const trackRaptorSearch = ({ query, culture, market }: TrackRaptorSearchOpts) => {
	return fetcher(
		buildURL(RAPTOR_SEARCH_ENDPOINT, {
			culture,
			market,
			q: query,
		}),
	)();
};

type TrackRaptorPageViewOpts = TrackRaptorGenericOpts & {
	page: string;
	contentIds: string[];
};

export const trackRaptorPageView = async ({ contentIds, ...rest }: TrackRaptorPageViewOpts) => {
	try {
		const url = buildURL(RAPTOR_PAGE_VIEW_ENDPOINT, {
			...rest,
			contentIds: contentIds.join(','),
		});

		const request = fetcher(url);
		await request();
	} catch (e: any) {
		// TODO: handle failed Raptor responses
		console.error(e.message);
	}
};

type TrackRaptorDirectPageViewOpts = {
	raptorTrackingUrl: string;
	pageId: string;
	language: string;
	market: string;
	moduleIds: string[];
	currentUrl: string;
	// Marketing consent parameters (optional)
	ruid?: string;
	reaid?: string;
	sessionId?: string;
	cookieId?: string;
};

export const trackRaptorDirectPageView = async ({ raptorTrackingUrl, pageId, language, market, moduleIds, currentUrl, ruid, reaid, sessionId, cookieId }: TrackRaptorDirectPageViewOpts) => {
	try {
		const params = new URLSearchParams({
			p1: 'pageview',
			p9: pageId,
			p27: language,
			p28: market,
			p42: moduleIds.join(','),
			url: currentUrl,
		});

		// Add marketing consent parameters if provided
		if (ruid) params.append('ruid', ruid);
		if (reaid) params.append('reaid', reaid);
		if (sessionId) params.append('sid', sessionId);
		if (cookieId) params.append('coid', cookieId);

		const fullUrl = `${raptorTrackingUrl}?${params.toString()}`;

		// Use navigator.sendBeacon for direct tracking
		await navigator.sendBeacon(fullUrl);
	} catch (e: any) {
		// TODO: handle failed Raptor responses
		console.error('❌ Raptor direct tracking failed:', e.message);
	}
};
